/**
 * Preferred column order for read-only bailiff refund detail views.
 * Matches `bailiff_refund_request` / `BaillifRefundRequest.tsx` payload fields.
 */
export const BAILIFF_REFUND_DETAIL_KEY_ORDER: string[] = [
  'bailiff_refund_request_id',
  'transaction_reference',
  'status',
  'bailiff_email',
  'bailiff_phone_number',
  'link',
  'bailiff_assignee',
  'bailiff_national_id',
  'property_id',
  'execution_case_number',
  'amount',
  'transaction_currency',
  'reason',
  'bank_code',
  'debit_account_number',
  'debit_account_name',
  'beneficiary_account_name',
  'beneficiary_bank_name',
  'beneficiary_account_number',
  'bidder_id',
  'bid_security_id',
  'bidder_phone_number',
  'attachment',
  'otp',
  'otp_expiration',
  'created_at',
  'updated_at',
  'created_by'
]
